import { render, staticRenderFns } from "./SurveyIndex.vue?vue&type=template&id=b12df404&"
import script from "./SurveyIndex.vue?vue&type=script&lang=js&"
export * from "./SurveyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports